export default "__VITE_ASSET__BtK2iN7q__"